import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as angular from 'angular';
import { resolve } from 'url';
import { UntypedFormBuilder } from '@angular/forms';
import { PayGateService } from 'app/services/paygate.service';
import { CarrierService } from 'app/services/carrier.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { accounting } from 'accounting';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-account-deposit',
  templateUrl: './paymentComplete.component.html',
  styleUrls: ['./paymentComplete.component.css'] 
  
})
export class PaymentCompleteComponent implements OnInit {
  @Input() dataCntrl: any;
  @Input() isApproval: boolean = false;
  
  isLoading = false;
  message = "Loading. Please wait...";
  instructMsg = '';
  departuresList: any = [];
  departuresListRemove: any = [];
  editFlag: boolean = false;
  pageload: boolean = false;
  showBlock: boolean = false;
  
  payReqId: string = "";
  checkSum: string = "";
  carrierid : any;
  Carrier : any;
  amountDisplay : any;
  amount:any;
  paymentRef: string = "";
  status : number;
  statusDesc : string = "";



  constructor(private formBuilder: UntypedFormBuilder, 
    private payGateService:PayGateService,
    private carrierService:CarrierService,
    private activeRoute: ActivatedRoute,
    private msgService: PopupService,
    private msg: ToastrService,
    private router:Router) {}

  ngOnInit() {
    this.activeRoute.params.subscribe((params: Params) => {
    this.carrierid = params['id'];
    this.status = Number(params['status']);
    this.paymentRef = params['refNum'];
    switch(this.status)
    {
      case 0 :
          this.statusDesc = "Not Done";
        break;
        case 1 :
          this.statusDesc = "Approved";
        break;
        case 2 :
          this.statusDesc = "Declined";
        break;
        case 3 :
          this.statusDesc = "Cancelled";
        break;
        case 4 :
          this.statusDesc = "User Cancelled";
        break;
        case 5 :
          this.statusDesc = "Received by PayGate";
        break;
        case 7 :
          this.statusDesc = "Settlement Voided";
        break;
    }

    this.LoadCarrierAccountDetails();
    });

    
    
  }

  

  formatCurrency(value) {
    return accounting.formatMoney(value, 'R', 2, ' ', '.');
  }

  LoadCarrierAccountDetails()
  {
    this.carrierService.getById(this.carrierid).subscribe(carrier=>{
      this.Carrier = carrier;
      console.log(carrier);
    });
  }


   
  backToTab() {
    this.router.navigateByUrl('carrier/accounts/VCA');
  }
}
 